import type { SVGProps } from 'react';

export interface PeriscopeLogoProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

/**
 * Periscope brand mark: a geometric periscope silhouette (base, shaft, angled
 * head, lens). Stroke-based to match lucide icon styling, uses currentColor
 * so it adapts to the active theme. Renders cleanly from 24px (sidebar) up
 * to ~64px+ (login screen).
 */
export function PeriscopeLogo({ className, ...props }: PeriscopeLogoProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...props}
    >
      {/* base / eyepiece foot */}
      <path d="M5 20h10" />
      {/* vertical shaft */}
      <path d="M10 20V9" />
      {/* angled head tube */}
      <path d="M10 9l6-4.5" />
      {/* objective lens */}
      <circle cx="18" cy="3.3" r="1.7" fill="currentColor" stroke="none" />
    </svg>
  );
}
